import {
  DefaultGuideImage,
  DefaultImage,
  DefaultPodcastImage,
  DefaultVideoImage,
} from '@shared/ui-components/assets/';

import { ContentType } from '../data/constants/content-type';

export const getContentFallbackImageSource = (contentType: null | number | undefined) => {
  switch (contentType) {
    case ContentType.Audio:
    case ContentType.Podcast:
      return DefaultPodcastImage;
    case ContentType.Guide:
      return DefaultGuideImage;
    case ContentType.Video:
      return DefaultVideoImage;
    case ContentType.Article:
    default:
      return DefaultImage;
  }
};
